// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-select--tn[data-v-6bc90c80]{--input-b:1px solid #7d838c!important;--input-br:16px!important;--input-svg-size:24px!important;--font-weight:400;--font-size:16px;--line-height:24px}.v-select--tn .v-select__container[data-v-6bc90c80]:focus,.v-select--tn .v-select__container[data-v-6bc90c80]:hover{outline:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
